import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { SubscriptionPurchaseFTUEContext } from './SubscriptionPurchaseFTUEContext';
import s from './SubscriptionPurchaseFTUE.scss';
const ILLUSTRATION_URL = Url.staticCDNLink('eclipse/global/svg/congrats-ms-hexagon.svg');
/** Displays a ftue popup for viewers of in-tier deviations after
 *  their first time subscribing to a tier. */ export const SubscriptionPurchaseFTUE = ({ className })=>{
    const { t } = useTranslation();
    const isMounted = useIsMounted();
    const ftuePhase = useContext(SubscriptionPurchaseFTUEContext);
    const isShown = !!ftuePhase;
    if (!isShown) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isMounted && s['mounted'], ftuePhase !== 'overlay' && s['fading-out'], className)
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['illustration'],
        src: ILLUSTRATION_URL,
        alt: ""
    }), /*#__PURE__*/ React.createElement("section", {
        className: s['ftue-explanation']
    }, /*#__PURE__*/ React.createElement("h6", {
        className: s['heading']
    }, t('deviation.tier.ftue.subscriptionUnlocked.heading')), /*#__PURE__*/ React.createElement("p", null, t('deviation.tier.ftue.subscriptionUnlocked.explanation')), /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement(TextButton, {
        className: s['got-it'],
        size: "small",
        variant: "approval-green"
    }, t('deviation.tier.ftue.subscriptionUnlocked.gotIt')))));
};
SubscriptionPurchaseFTUE.displayName = 'SubscriptionPurchaseFTUE';
export default SubscriptionPurchaseFTUE;

//# sourceMappingURL=SubscriptionPurchaseFTUE.js.map